module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAz0lEQVQ4T62Tyw3CMAxAXyeAEWADRuDMiRG6AYzQEWADRuiJc0dgAxgBNkCvSlAIQVQKliKrdvz8adzwKQtgByyBeXDfgStwBG5pSJPFH0KQ+pL5VsAeEKYeJQUMwCmcQmEvUwt41ikgZhQwRQSMFVmBPXeBarAOpdRCajdZJ8DsfsQAAT2wnWBrBcTLaekpRHsOjHd7AQ5vHEhh6udg2xRa0jX8BVDdQvUQq3+jw6h6SHH4VU85Qn4tk1v6+LZMEeJM3Db1LBgNco1N8LbOT0feQlE3i5anAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/delete-on.png
// module id = azo6
// module chunks = 61